namespace $.$$ {

	export class $shm_agent_session_menu extends $.$shm_agent_session_menu {

		menu_rows() {
			return this.remove_confirmed() ? super.menu_rows() : [ this.Pin(), this.Archive(), ... super.menu_rows() ]
		}

		archive_title() {
			return this.archived() ? 'Убрать из архива' : 'Архив'
		}

		@ $mol_action
		archive_toggle( next?: Event ) {
			if( next === undefined ) return null
			this.archived( !this.archived() )
			this.showed( false )
			return next
		}

		pin_title() {
			return this.pinned() ? 'Открепить' : 'Закрепить'
		}

		@ $mol_action
		pin_toggle( next?: Event ) {
			if( next === undefined ) return null
			this.pinned( !this.pinned() )
			this.showed( false )
			return next
		}

	}

}
